import styles from './calendar-card.module.scss';
import { MiniCalendar } from 'features/index';
import { observer } from 'mobx-react';
import { ICalendarDate } from 'entities/calendar/model/calendar-date';
import { dayCalendarStore } from 'entities/index';

export const CalendarCard = observer(() => {
  const selectedDateHandler = (date: ICalendarDate) => {
    dayCalendarStore.selectedDate = date;
  };
  return (
    <div className={styles.calendar_card__container}>
      <div className={styles.container__content}>
        <div className={styles.content__calendar}>
          <MiniCalendar selectedDateHandler={selectedDateHandler} />
        </div>
      </div>
    </div>
  );
});
